import { useCallback, useMemo, useState } from 'react';

import { useSearchState } from '@fly/shared-hooks';
import { SortingState } from '@tanstack/react-table';

import { TableStateType } from '../TanstackTable.types';

const SORT_PARAM_KEY = 'sort';
const DIRECTION_PARAM_KEY = 'direction';
export const serializeSearchSorting = (
  value: SortingState | undefined,
  params: URLSearchParams
) => {
  if (value?.[0]) {
    params.set(SORT_PARAM_KEY, value[0].id);
    params.set(DIRECTION_PARAM_KEY, value[0].desc ? 'desc' : 'asc');
  } else {
    //TODO need to remove ?
    params.delete(SORT_PARAM_KEY);
    params.delete(DIRECTION_PARAM_KEY);
  }
  return params;
};
const deserializeSearchSorting = (value: URLSearchParams) => {
  const sort = value.get(SORT_PARAM_KEY);
  const direction = value.get(DIRECTION_PARAM_KEY);
  if (sort && direction) {
    return [{ id: sort, desc: direction === 'desc' }];
  }
  return undefined;
};

export function useTableSortingState(stateType: TableStateType) {
  const [searchSorting, setSearchSorting] = useSearchState<
    SortingState | undefined
  >({
    initialValue: undefined,
    serialize: serializeSearchSorting,
    deserialize: deserializeSearchSorting,
  });

  const [stateSorting, setStateSorting] = useState<SortingState | undefined>(
    undefined
  );

  const setSorting = useCallback(
    (sorting: SortingState) => {
      if (stateType === 'search') {
        setSearchSorting(sorting);
        return;
      }

      setStateSorting(sorting);
    },
    [setSearchSorting, stateType]
  );

  const sorting: SortingState | undefined = useMemo(() => {
    if (stateType === 'search') {
      return searchSorting;
    }

    return stateSorting;
  }, [stateSorting, stateType, searchSorting]);

  return {
    sorting,
    setSorting,
  };
}
